// redux
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducers } from './reducers';

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware))
// store.js
export default createStore(reducers, composedEnhancer);
